
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/header",
      function () {
        return require("private-next-pages/[lang]/header/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/header"])
      });
    }
  